import Api from '@/apis/photos-api';

const breadcrumb = {
  state: {
    breadcrumb: []
  },
  getters: {
    breadcrumb(state) { return state.breadcrumb; }
  },
  actions: {
    breadcrumb({ commit }, payload) {
      return Api.get('breadcrumb', payload).then((response) => {
        commit('breadcrumb', response.data);
      }).catch((error) => {
        console.log(error);
      });
    },
    // click on thumb-items adds breadcrumb
    addBreadcrumb({ commit }, payload) {
      commit('addBreadcrumbItem', payload);
    },
    removeBreadcrumbItems({ commit }, payload) {
      commit('removeBreadcrumbItems', payload.id);
    }
  },
  mutations: {
    breadcrumb(state, data) {
      state.breadcrumb = data;
    },
    addBreadcrumbItem(state, view) {
      state.breadcrumb.push(view);
    },
    removeBreadcrumbItems(state, id) {
      const index = state.breadcrumb.findIndex(breadcrumbItem => breadcrumbItem.id === id);
      state.breadcrumb = state.breadcrumb.slice(0, index + 1);
    },
    removeAllBreadcrumbItems(state) {
      state.breadcrumb = [];
    }
  }
};

export default breadcrumb;



// WEBPACK FOOTER //
// ./src/store/breadcrumb/index.js